import React from "react";
import { channelSearchStatus } from "./channel-search.status";
import { withSafeRender } from "../../atoms/safe-render";

/**
 * AX11 — "a screen reader announces the typing hint, the no-match message and
 * the number of suggestions as they change".
 *
 * The one thing in this component only screen-reader readers ever meet. It is
 * ALWAYS rendered, empty when there is nothing to say: a live region added to
 * the DOM at the moment it gains content is not announced, because the
 * platform only watches regions it was already watching.
 *
 * `polite`, so it waits for a gap rather than cutting across the keystroke
 * that caused it.
 */
export interface SearchStatusProps {
  id: string;
  query: string;
  matchCount: number;
  typingHint: string;
  emptyMessage: string;
}

function SearchStatusImpl({ id, ...state }: SearchStatusProps) {
  return (
    <p aria-live="polite" className="dds-sr-only" id={id}>
      {channelSearchStatus(state)}
    </p>
  );
}
export const SearchStatus = withSafeRender(SearchStatusImpl, "SearchStatus");

export default SearchStatus;
